export const integrationsData = (companyIntegrations) => [
    {
        name: 'Vivid Seats',
        logo: '/logos/Vivid-Seats-Logo.png',
        portal: 'https://brokers.vividseats.com/',
        lastSync: companyIntegrations.integrations_data.vivid_seats_connected
            ? companyIntegrations.integrations_data.last_synced
            : null,
        isConnected: companyIntegrations.integrations_data.vivid_seats_connected,
    },
    {
        name: 'Automatiq B2B',
        logo: '/logos/automatiq-b2b-logo.png',
        portal: 'https://automatiq.com/',
        lastSync: companyIntegrations.integrations_data.automatiq_b2b_connected
            ? companyIntegrations.integrations_data.last_synced
            : null,
        isConnected: companyIntegrations.integrations_data.automatiq_b2b_connected,
    },
    {
        name: 'Seat Geek',
        logo: '/logos/seat-geek-logo.png',
        portal: 'https://sellers.seatgeek.com',
        lastSync: companyIntegrations.integrations_data.seat_geek_connected
            ? companyIntegrations.integrations_data.last_synced
            : null,
        isConnected: companyIntegrations.integrations_data.seat_geek_connected,
    },
];
